import React, { PropsWithChildren } from 'react'
import { Box, BoxProps } from '@node-space/ui-components'

export type SidePanelBodyProps = BoxProps & PropsWithChildren

export const SidePanelBody = ({ children, ...boxProps }: SidePanelBodyProps) => {
  return (
    <Box paddingX={20} paddingT={24} paddingB={32} {...boxProps}>
      {children}
    </Box>
  )
}
